<template>
    <div class="layout">
  
      <!-- 검색 영역 -->
      <div class="sp-search">
        <h2>국내외 문화 통계 사이트</h2>
        <!-- 검색폼 : 개발 된 컴포넌트 사용하시면 됩니다. -->
        <div class="search-wrap align-end">
          <div class="search-box">
            <label for="sortGubun" class="ir">검색순서</label>
            <select id="sortGubun">
              <option value="">최신순</option>
            </select>
            <label for="classCode" class="ir">검색카테고리</label>
            <select id="classCode">
              <option value="">전체</option>
              <option value="">공연예술조사</option>
              <option value="">호텔업운영현황</option>
            </select>
            <label for="statReportSearchText" class="ir">검색창</label>
            <input type="search" id="statReportSearchText" /><button type="submit">검색</button>
          </div>
        </div>
        <!-- // 검색폼 -->
      </div>
      <!-- // 검색 영역 -->
  
      <!-- 목록 -->
      <div class="sp-cate-list">
        <ul>
          <li>
            <a href="#n">
              <div class="thum"><img src="../../assets/img/img_sp_thum.png" alt=""></div>
              <div class="cate-info-box">
                <div class="cate-tit"><h4>저작권 산업 특수분류 (https://kssc.kostat.go.kr:8443/)</h4></div>
                <dl class="cate-info">
                  <dt>개요</dt>
                  <dd>
                    창작물 및 보호대상물 (소설․시․음악․미술․지도․설계도안․영화․소프트웨어 등)의 창작, 생산, 공연, 방송, 전시 또는 도소매 활동을 영위하는 산업과 저작권이 
                    그 산업의 수립에 중요한 역할을 하는 산업(WIPO, 「저작권기반산업의 경제적기여도 조사 가이드」) 저작권 (copyright)은 창작물을 만든이(저작자)가 자기
                    저작물을 통제하고, 그로부터 이익을 얻을 수 있는 권리
                  </dd>
                </dl>
              </div>
            </a>
          </li>
          <li>
            <a href="#n">
              <div class="thum"><img src="../../assets/img/img_sp_thum.png" alt=""></div>
              <div class="cate-info-box">
                <div class="cate-tit"><h4>저작권 산업 특수분류 (https://kssc.kostat.go.kr:8443/)</h4></div>
                <dl class="cate-info">
                  <dt>개요</dt>
                  <dd>
                    창작물 및 보호대상물 (소설․시․음악․미술․지도․설계도안․영화․소프트웨어 등)의 창작, 생산, 공연, 방송, 전시 또는 도소매 활동을 영위하는 산업과 저작권이 
                    그 산업의 수립에 중요한 역할을 하는 산업(WIPO, 「저작권기반산업의 경제적기여도 조사 가이드」) 저작권 (copyright)은 창작물을 만든이(저작자)가 자기
                    저작물을 통제하고, 그로부터 이익을 얻을 수 있는 권리
                  </dd>
                </dl>
              </div>
            </a>
          </li>
          <li>
            <a href="#n">
              <div class="thum"><img src="../../assets/img/img_sp_thum.png" alt=""></div>
              <div class="cate-info-box">
                <div class="cate-tit"><h4>저작권 산업 특수분류 (https://kssc.kostat.go.kr:8443/)</h4></div>
                <dl class="cate-info">
                  <dt>개요</dt>
                  <dd>
                    창작물 및 보호대상물 (소설․시․음악․미술․지도․설계도안․영화․소프트웨어 등)의 창작, 생산, 공연, 방송, 전시 또는 도소매 활동을 영위하는 산업과 저작권이 
                    그 산업의 수립에 중요한 역할을 하는 산업(WIPO, 「저작권기반산업의 경제적기여도 조사 가이드」) 저작권 (copyright)은 창작물을 만든이(저작자)가 자기
                    저작물을 통제하고, 그로부터 이익을 얻을 수 있는 권리
                  </dd>
                </dl>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <!-- // 목록 -->
  
      <!-- 페이징 : 개발 된 컴포넌트 사용하시면 됩니다. -->
      <div class="page_wrap">
        <div class="page_nation align-center">
          <a class="arrow pprev" href="#" title="맨앞으로">
            <img src="../../assets/img/paging_pprev.png" alt="맨앞으로">
          </a>
          <a class="arrow prev" href="#" title="이전으로">
            <img src="../../assets/img/paging_left.png" alt="이전으로">
          </a>
          <a href="#" class="active">1</a>
          <a href="#" class="">2</a>
          <a href="#" class="">3</a>
          <a class="arrow next" href="#" title="다음으로">
            <img src="../../assets/img/paging_right.png" alt="다음으로">
          </a>
          <a class="arrow nnext" href="#" title="맨마지막으로">
            <img src="../../assets/img/paging_nnext.png" alt="맨마지막으로">
          </a>
        </div>
      </div>
      <!-- // 페이징 -->
  
    </div>
  </template>
      
  <script>
    export default {
      name: 'statsSite',
      mounted () {
      },
      methods: {
      }
    }
  </script>
  
  <style scoped>
  
  </style>
    